package com.example.mystybag.login.logic

import com.example.mystybag.common.logic.DialogNavigatorForceUpdate
import com.example.mystybag.common.logic.NavigatorChooseCity
import com.example.mystybag.common.logic.NavigatorVerifyEmailAddress
import com.example.mystybag.common.resources.SR
import com.example.mystybag.communication.login.LoginCommands
import com.example.mystybag.communication.login.LoginCommands.sendEnroll
import com.example.mystybag.communication.utils.Response
import com.example.mystybag.communication.utils.onResponse
import com.example.mystybag.core.defines.UtilsPreferencesDefines.PREFERENCES_EMAIL
import com.example.mystybag.core.expected.Preferences
import com.example.mystybag.core.expected.openAppStorePage
import com.example.mystybag.core.expected.sharedString
import com.example.mystybag.core.helpers.GlobalCommonData.getReferralCodeValue
import com.example.mystybag.core.extensions.isValidEmail
import com.example.mystybag.core.logic.base.AppContext
import com.example.mystybag.core.logic.base.ChildViewModel
import com.example.mystybag.login.model.EnterEmailUIState
import com.example.mystybag.sharedmodels.base.BaseResponseModel
import com.example.mystybag.sharedmodels.defines.ServerStatusDefines.Companion.STATUS_MANDATORY_UPDATE
import com.example.mystybag.sharedmodels.mobileAdmin.database.UsersCredentialTypes
import com.example.mystybag.sharedmodels.project.requestModels.CheckUserExistsRequestModel
import com.example.mystybag.sharedmodels.project.requestModels.EnrollUserRequestModel

class EnterEmailViewModel(context: AppContext): ChildViewModel<EnterEmailUIState>(context, EnterEmailUIState()) {
    override fun onCreate() {
    }

    fun onEmailChange(email: String) {
        updateState {
            it.copy(email = email, emailIsError = false)
        }
    }

    fun onNextClicked() {
        if(validate()) {
            sendCheckUserExists()
        }
    }

    private fun sendCheckUserExists() {
        val email = uiState.value.email
        updateState { it.copy(isLoading = true) }
        commandBlock {
            LoginCommands.sendCheckUserExists(CheckUserExistsRequestModel(email = email))
                .onResponse(
                    success = { response ->
                        launchOnMain {
                            updateState { it.copy(isLoading = false) }
                            if (response.isExistingUser) {
                                sendEnrollCommand()
                            } else {
                                navigate(NavigatorChooseCity(
                                    userId = 0L,
                                    email = email,
                                    credentialTypes = UsersCredentialTypes.STANDARD
                                ))
                            }
                        }
                    },
                    baseError = { response ->
                        handleError(response)
                    }
                )
        }
    }

    private fun sendEnrollCommand() {
        updateState { it.copy(isLoading = true) }
        commandBlock {
            sendEnroll(
                request = EnrollUserRequestModel(
                    email = uiState.value.email,
                    credentialTypes = UsersCredentialTypes.STANDARD,
                    referralCode = getReferralCodeValue()
                )
            )
                .onResponse(
                    success = { response ->
                        // Save email and userId
                        Preferences.setString(PREFERENCES_EMAIL, uiState.value.email)
                        
                        launchOnMain {
                            updateState { it.copy(isLoading = false) }

                            navigate(NavigatorVerifyEmailAddress(
                                userId = response.userId,
                                email = uiState.value.email,
                                cityId = 0L
                            ))
                        }
                    },
                    baseError = { response ->
                        handleError(response)
                    }
                )
        }
    }

    private suspend fun handleError(model: BaseResponseModel) {
        updateState { it.copy(isLoading = false) }
        when (model.status) {
            STATUS_MANDATORY_UPDATE -> showDialog(DialogNavigatorForceUpdate).onPositiveClick { openAppStorePage() }
            else -> showSnackbar(Response.getErrorMessage(model.status, model.apiEndPoint, model.statusMessage))
        }
    }

    private fun validate(): Boolean {
        return when {
            uiState.value.email.isEmpty() ||  !uiState.value.email.isValidEmail-> {
                updateState {
                    it.copy(
                        emailErrorMsg   = sharedString(SR.strings.please_enter_valid_email_address),
                        emailIsError    = true
                    )
                }
                false
            }
            else -> true
        }
    }

}